import { getAllTypes } from '@/api/recycle.js';

const typeList = {
    state: {
        info: []
    },
    mutations: {
        //获取分类列表
        SET_TYPE_INFO(state, resultArr) {
            state.info = resultArr
        }
    },
    actions: {
        //获取分类列表
        async getTypeInfo({ commit }) {
            await getAllTypes().then(res => {
                if (res.data.code == '100001') {
                    let tempArr = [];
                    res.data.result.forEach(item => {
                        tempArr.push({
                            'name': item.name,
                            'code': item.id.toString()
                        })
                    })
                    commit('SET_TYPE_INFO', tempArr)
                }
            })
        }
    }
}

export default typeList


// WEBPACK FOOTER //
// ./src/store/modules/typeList.js